import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AccVentureStatusType } from '@interfaces';
import { DeliveryAreaService } from '../../../../delivery-area.service';
import { DeliveryOverviewService } from '../../../delivery-overview.service';
import { getSetup } from './grid/get-setup';

export interface DeliveryAccEntrepreneur {
	accEntrepreneurId: number,
	personId: number,
	name: string,
	location: string | undefined,
	accId: number,
	accName: string,
	accTeamId: number,
	accVentureId: number,
	ventureName: string,
	ventureStatus: AccVentureStatusType,
	courseCompletionPercentage: number,
	presentCount: number,
	absentCount: number,
	surveysCount: number,
	updatedUTC: number,
}

@Component({
	selector: 'delivery-all-entrepreneurs-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './all-entrepreneurs-view.part.html',
})
export class DeliveryAllEntrepreneursViewPart {

	private readonly util = inject(UtilityService);
	private readonly dialog = inject(DialogService);
	private readonly pageService = inject(DeliveryOverviewService);
	private readonly areaService = inject(DeliveryAreaService);

	public setup = computed(() => getSetup(this.util, this.dialog, this.areaService));

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public allEntrepreneurs = computed<DeliveryAccEntrepreneur[]>(() => {
		const data = this.areaService.deliveryData();
		if (!data) return [];

		const accById = this.util.array.toMap(data.accelerators, a => a.accId);

		const surveysByEntPersonId = this.util.array.toArrayMap(data.accSurveysResponses, s => s.entrepreneurPersonId);

		const ents: DeliveryAccEntrepreneur[] = [];

		data.allVentures.forEach(venture => {
			venture.entrepreneurs.forEach(ent => {
				ents.push({
					accEntrepreneurId: ent.accEntrepreneurId,
					personId: ent.personId,
					name: ent.name,
					location: ent.location,
					accId: venture.accId,
					accName: accById[venture.accId]?.name ?? '',
					accTeamId: venture.accTeamId,
					accVentureId: venture.accVentureId,
					ventureName: venture.ventureName,
					ventureStatus: venture.status,
					courseCompletionPercentage: ent.courseCompletionPercentage,
					presentCount: ent.presentCount,
					absentCount: ent.absentCount,
					surveysCount: surveysByEntPersonId[ent.personId]?.length ?? 0,
					updatedUTC: ent.updatedUTC,
				});
			});
		});

		return ents;
	});
}